import { useTransition, type FC } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { Button } from '@packages/shared/src/ui/Button/Button';

export type InfiniteLoadingFooterProps = {
  seenProductCount: number;
  totalProductCount: number;
  onLoadMore: () => void;
};

const messages = defineMessages({
  text: {
    id: 'search.productList.infiniteLoading.footer.text',
    defaultMessage: 'Du hast {seenProductCount} von {totalProductCount} Artikeln gesehen',
  },
  loadMore: {
    id: 'search.productList.infiniteLoading.footer.loadMore',
    defaultMessage: 'Mehr Artikel anzeigen',
  },
});

export const InfiniteLoadingFooter: FC<InfiniteLoadingFooterProps> = ({
  seenProductCount,
  totalProductCount,
  onLoadMore,
}) => {
  const { formatMessage } = useIntl();

  const [isLoading, startTransition] = useTransition();

  return (
    <div className="[grid-column:1/-1] [grid-row:span_1] flex flex-col gap-2 place-self-center">
      <span className="text-size-body-sm">
        {formatMessage(messages.text, { seenProductCount, totalProductCount })}
      </span>
      <div className="bg-color-grey mx-2 h-[2px]">
        <div
          className="bg-color-grey-dark h-full"
          style={{ width: `${(seenProductCount / totalProductCount) * 100}%` }}
        />
      </div>
      {seenProductCount < totalProductCount && (
        <Button
          disabled={isLoading}
          onClick={() => {
            startTransition(() => {
              onLoadMore();
            });
          }}
          className={isLoading ? 'animate-pulse' : ''}
        >
          {formatMessage(messages.loadMore)}
        </Button>
      )}
    </div>
  );
};
